document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.card--detailed');

  cards.forEach((card) => {
    const plusInfoButton = card.querySelector('.card__plus-info');
    const plusInfoText = card.querySelector('.card__plus-info--text');

    // Verifica se esistono gli elementi prima di procedere
    if (plusInfoButton && plusInfoText) {
      plusInfoButton.addEventListener('click', function () {
        card.classList.toggle('card--expanded');

        if (plusInfoText.style.visibility === 'hidden' || plusInfoText.style.visibility === '') {
          plusInfoText.style.opacity = '1';
          plusInfoText.style.visibility = 'visible';
        } else {
          plusInfoText.style.opacity = '0';
          plusInfoText.style.visibility = 'hidden';
        }
      });
    }
  });
});
